module.exports = __webpack_public_path__ + "static/media/pout-cerny-celek.4b8f5a99.jpg";